import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

const ServerError = () => (
  <div className="min-h-screen flex items-center justify-center bg-muted p-6">
    <div className="max-w-md w-full text-center rounded-2xl border border-border bg-card p-8 shadow-card">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <AlertTriangle className="h-6 w-6" />
      </div>
      <h1 className="text-3xl font-bold text-foreground">500</h1>
      <p className="mt-2 text-lg text-foreground">Something went wrong on our end.</p>
      <p className="mt-1 text-sm text-muted-foreground">
        Please try again in a moment. If it keeps happening, let us know via the feedback button.
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-2">
        <Button onClick={() => window.location.reload()}>Try again</Button>
        <Button variant="outline" asChild>
          <Link to="/">Go home</Link>
        </Button>
      </div>
    </div>
  </div>
);

export default ServerError;